import { Outlet, NavLink, useNavigate } from "react-router-dom";
import Sidebar, { NAV, BrandHeader, BrandToggle, UserFooter } from "@/components/Sidebar";
import { Menu, X, LogOut } from "lucide-react";
import { useState, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useBrand } from "@/contexts/BrandContext";
import FeedbackWidget from "@/components/FeedbackWidget";

export default function Layout() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const { brand, setBrand } = useBrand();
  const nav = useNavigate();
  const onLogout = async () => { await logout(); nav("/login"); };

  // Lock scroll when drawer open
  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <div className="flex bg-[var(--blanc-casse)] min-h-screen">
      <Sidebar />

      {/* Mobile top bar */}
      <div className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-white border-b border-[var(--border)] px-4 py-3 flex items-center justify-between">
        <div>
          <div className="font-display font-bold text-base leading-none tracking-tight">Pourquoi Pas Design</div>
          <div className="text-[9px] text-stone-500 uppercase tracking-[0.18em] mt-0.5">Architecture · Franchise · Déploiement</div>
        </div>
        <button data-testid="mobile-menu-button" onClick={() => setOpen(true)} aria-label="Ouvrir le menu" className="text-stone-700 p-1">
          <Menu size={22} />
        </button>
      </div>

      {/* Mobile drawer */}
      {open && (
        <div className="lg:hidden fixed inset-0 z-50 flex" data-testid="mobile-drawer">
          <div className="absolute inset-0 bg-black/40" onClick={() => setOpen(false)}/>
          <div className="relative ml-auto w-72 max-w-[85vw] h-full bg-white shadow-xl flex flex-col">
            <div className="flex items-center justify-between p-4 border-b border-[var(--border)]">
              <div>
                <div className="font-display font-bold text-base leading-none">Pourquoi Pas Design</div>
                <div className="text-[9px] text-stone-500 uppercase tracking-[0.18em] mt-0.5">Architecture · Franchise · Déploiement</div>
              </div>
              <button onClick={() => setOpen(false)} aria-label="Fermer le menu" className="text-stone-700 p-1"><X size={20}/></button>
            </div>
            <BrandToggle brand={brand} setBrand={setBrand}/>
            <nav className="flex-1 overflow-y-auto px-3 py-3 space-y-0.5">
              {NAV.map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  end={n.to === "/"}
                  data-testid={`m-${n.testid}`}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => `sidebar-link ${isActive ? "active" : ""}`}
                >
                  <n.icon size={16} strokeWidth={1.8} />
                  <span>{n.label}</span>
                </NavLink>
              ))}
            </nav>
            <UserFooter user={user} onLogout={onLogout}/>
          </div>
        </div>
      )}

      <main className="flex-1 min-w-0 pt-14 lg:pt-0">
        <div className="max-w-[1400px] mx-auto p-4 md:p-8 animate-fade-in">
          <Outlet />
        </div>
      </main>
      <FeedbackWidget />
    </div>
  );
}
